import { createFileRoute } from "@tanstack/react-router";

import { THREAD_SPLITTER_FAQS } from "@/components/marketing/thread-splitter-faqs";
import { ThreadSplitterTool } from "@/components/marketing/thread-splitter-tool";
import { toolPageHead } from "@/lib/seo";

/**
 * `head` is never code-split, so it must not reach into the component module —
 * that would drag the whole tool into the shared entry chunk. The FAQs live in
 * their own module for exactly this reason; see `thread-splitter-faqs.ts`.
 */
export const Route = createFileRoute("/(public)/tools/thread-splitter")({
  head: () => toolPageHead("threadSplitter", THREAD_SPLITTER_FAQS),
  component: ThreadSplitterTool,
});
